import React from "react";
import HotelTicketScreen from "../../../common/AllTickets/Hotel/HotelTicketScreen";
function SuperHotelTicket() {
  return <HotelTicketScreen mode="ADMIN" />;
}

export default SuperHotelTicket;
